import { Component } from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";

@Component({
    selector: 'app-acknowledgements',
    templateUrl: './acknowledgements.component.html',
    standalone: true,
  imports: [
    NgForOf,
    NgIf
  ],
    styleUrl: './acknowledgements.component.css'
})
export class AcknowledgementsComponent {
  makers = [
    { name: "Erika Attidzah", role: "Software Development Intern (2025)", linkedIn: "http://linkedin.com/in/erika-attidzah-302a19306" },
    { name: "Sean Nolan", role: "Software Development Intern (2025)", linkedIn: "https://www.linkedin.com/in/sean-nolan-83b55b189/" },
    { name: "Stephen Wood", role: "Software Development Intern (2024)", linkedIn: "https://www.linkedin.com/in/stephen-wood-a85160333/" },
    { name: "Luis Enrique Fabela Nieto", role: "Software Development Intern (2024)", linkedIn: "https://www.linkedin.com/in/luis-fabela-b84249265/" },
    { name: "Tripp Barker", role: "Software Development Student (Spring 2024)", linkedIn: "https://www.linkedin.com/in/tripp-barker-367660b0" },
    { name: "Muhammad Marenah", role: "Software Development Student (Spring 2024)", linkedIn: "https://www.linkedin.com/in/muhammad-marenah/" },
  ];
}
